import { render, staticRenderFns } from "./OrderStepsComponent.vue?vue&type=template&id=7bd37b90&scoped=true&"
import script from "./OrderStepsComponent.vue?vue&type=script&lang=ts&"
export * from "./OrderStepsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./OrderStepsComponent.vue?vue&type=style&index=0&id=7bd37b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd37b90",
  null
  
)

export default component.exports